import { FC, useCallback, ChangeEventHandler } from "react";
import { set } from "monolite";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import { POSITION_SLUG } from "pages/single-program/constants";

import { POSITION } from "./constants";

import type { StepViewProps } from "../../types";

import { PositionData } from "./interfaces";

export interface PositionProps extends StepViewProps<typeof POSITION_SLUG> {}

export const Position: FC<PositionProps> = ({
  value: values,
  slug,
  onChange,
}) => {
  const handleChange = useCallback<
    ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  >(
    (event) => {
      const numericValue = event.target.value;

      if (!/^\d*$/.test(numericValue)) return;

      onChange(
        set(
          values,
          (_) => _[event.target.name as keyof PositionData],
          numericValue,
        ),
        slug,
      );
    },
    [values, slug, onChange],
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          name={`${POSITION}`}
          label="Position"
          fullWidth
          variant="standard"
          type="number"
          value={values[POSITION]}
          onChange={handleChange}
          inputProps={{ min: 1 }}
        />
      </Grid>
    </Grid>
  );
};
